var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-view"},[_c('div',{staticClass:"page-view__content",staticStyle:{"flex":"1"}},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"page-view__footer"},[_c('in-viewport',[(!_vm.hideNavigation)?_c('footer-navigation-container'):_vm._e()],1),_vm._v(" "),_c('footer-component')],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17619eff","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageView.vue
// module id = null
// module chunks = 